<mat-card style="border-color: #5775a8;">
  <mat-card-header cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle style="background-color: #5775a8;">
    <div class="flex flex-row rounded-lg w-full" style="align-items: center;">
      <div class="flex flex-col w-full" style="padding-right: 20px;">
        <h4><span class="glyphicon glyphicon-file" style="color:white;"></span> Edit Enclosed Area</h4>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content>
    <form [formGroup]="form">
      <div class="flex flex-col w-full" style="padding: 10px;" *ngIf="isAdmin">
        <br />
        <h3>Enclosed Area (Administration Only):</h3>
        <span style="color: grey;">Review the attached files relating to this enclosed area and fill out the form
          below:</span>
        <br />
        <div class="flex flex-col w-full">

        </div>
        <div>
          <mat-radio-group formControlName="validEnclosedArea">
            <mat-radio-button color="primary" value='true'>Yes this is a valid enclosed area</mat-radio-button>
            <mat-radio-button color="primary" value='false'>No this is not a valid enclosed area</mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="row">
          <mat-form-field class="container">
            <mat-label>Date of Determination</mat-label>
            <input matInput [matDatepicker]="determineDate" (dateChange)="dateChanged($event.target.value)"
              formControlName="determineDate">
            <mat-datepicker-toggle matSuffix [for]="determineDate"></mat-datepicker-toggle>
            <mat-datepicker #determineDate></mat-datepicker>
            <mat-error *ngIf="form.get('determineDate').invalid">
              Invalid Date.
            </mat-error>
          </mat-form-field>
        </div>
        <div class="row">
          <mat-form-field class="w-full">
            <mat-label>Comments</mat-label>
            <textarea matInput cdkTextareaAutosize formControlName="comments" cdkAutosizeMinRows="6"></textarea>
          </mat-form-field>
        </div>
        <div class="flex flex-col w-full" *ngIf="enclosedArea.comments">
          <label>Visit Comments:</label>
          <span style="color:orange;">
            <p>
              {{enclosedArea.comments}}
            </p>
          </span>
        </div>
        <br />
        <hr style="border: 1px solid gray;">
        <br />
        <div class="flex flex-row w-full">
          <div style="padding-right: 20px;">
            <button mat-raised-button (click)="return()" class="m-8 container">
              Return
            </button>
          </div>
          <div style="padding-right: 20px;" *ngIf="showSave">
            <button mat-raised-button (click)="save()" class="m-8 container" style="background: #7ABDF3;">
              Update
            </button>
          </div>
        </div>
      </div>
      <div class="flex flex-col w-full" style="padding: 10px;" *ngIf="!isAdmin">
        <span style="color: red;">You are not authorized to edit this Enclosed Area.</span>
      </div>
    </form>

  </mat-card-content>

</mat-card>

